module.exports = __webpack_public_path__ + "img/xiaozi_gongxutong.3d80526a.png";